export const cardFees = {
    transparent: true,
};
